package example.shadcn_kotlin.ui.pages.docs.components.radio_group

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.RadioGroupDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/radio-group/index.md", mapOf("title" to listOf("Radio Group"), "description" to listOf("A set of checkable buttons—known as radio buttons—where no more than one of the buttons can be checked at a time."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/radio-group"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/radio-group#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import shadcn.ui.components.Label
import shadcn.ui.components.RadioGroup
import shadcn.ui.components.RadioGroupItem
import web.cssom.ClassName

val RadioGroupDemo = FC<Props> {
    RadioGroup {
        defaultValue = "comfortable"
        div {
            className = ClassName("flex items-center space-x-2")
            RadioGroupItem {
                value = "default"
                id = "r1"
            }
            Label {
                htmlFor = "r1"
                +"Default"
            }
        }
        div {
            className = ClassName("flex items-center space-x-2")
            RadioGroupItem {
                value = "comfortable"
                id = "r2"
            }
            Label {
                htmlFor = "r2"
                +"Comfortable"
            }
        }
        div {
            className = ClassName("flex items-center space-x-2")
            RadioGroupItem {
                value = "compact"
                id = "r3"
            }
            Label {
                htmlFor = "r3"
                +"Compact"
            }
        }
    }
}
"""){ 
 RadioGroupDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Label
import shadcn.ui.components.RadioGroup
import shadcn.ui.components.RadioGroupItem
""", lang= "kotlin", highlight= "")
            CodeBlock("""RadioGroup {
    defaultValue = "option-one"
    div {
        className = ClassName("flex items-center space-x-2")
        RadioGroupItem {
            value = "option-one"
            id = "option-one"
        }
        Label {
            htmlFor = "option-one"
            +"Option One"
        }
    }
    div {
        className = ClassName("flex items-center space-x-2")
        RadioGroupItem {
            value = "option-two"
            id = "option-two"
        }
        Label {
            htmlFor = "option-two"
            +"Option Two"
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
